import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { GenericError as ErrorView } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/errors';
import { CLONE_MODE, COPY_MODE, NEW_MODE } from '../../common/constants';
import { CalendarForm as NewCalendar } from './editable';
import { CalendarList } from './main';
import type { CalendarModalMainProps } from './types';

export const CalendarModalMain = ({ calendarsState, calendarsActions }: CalendarModalMainProps) => {
	const {
		isLoading,
		isError,
		permissionsWithTimezoneInfo,
		calendars,
		selectedCalendarMode,
		selectedCalendarId,
		copyCalendarData,
	} = calendarsState;

	if (isError) {
		return <ErrorView />;
	}

	if (isLoading || !permissionsWithTimezoneInfo || !calendars) {
		return <Spinner />;
	}

	return (
		<div data-test-id="servicedesk-sla-settings.ui.calendars.calendar-modal">
			{selectedCalendarMode === NEW_MODE && (
				<CalendarContainer>
					<NewCalendar
						allTimezones={permissionsWithTimezoneInfo.allTimezones}
						defaultTimezone={permissionsWithTimezoneInfo.defaultTimezone}
						onCancel={calendarsActions.onReset}
						onEditCalendarSuccessful={calendarsActions.onEditCalendarSuccessful}
						calendarMode={selectedCalendarMode}
					/>
				</CalendarContainer>
			)}
			{
				// @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"view" | "new" | "edit" | "collapsed"' and '"clone"' have no overlap.
				(selectedCalendarMode === COPY_MODE || selectedCalendarMode === CLONE_MODE) && (
					<CalendarContainer>
						<NewCalendar
							calendarData={copyCalendarData}
							allTimezones={permissionsWithTimezoneInfo.allTimezones}
							defaultTimezone={permissionsWithTimezoneInfo.defaultTimezone}
							onCancel={calendarsActions.onReset}
							onEditCalendarSuccessful={calendarsActions.onEditCalendarSuccessful}
							calendarMode={selectedCalendarMode}
						/>
					</CalendarContainer>
				)
			}
			<CalendarList
				selectedCalendarId={selectedCalendarId}
				calendars={calendars}
				permissionsWithTimezone={permissionsWithTimezoneInfo}
				selectedCalendarMode={selectedCalendarMode}
				calendarsActions={calendarsActions}
			/>
		</div>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CalendarContainer = styled.div({
	borderRadius: '3px',
	border: `1px solid ${token('color.border', 'rgba(9, 30, 66, 0.08)')}`,
	boxSizing: 'border-box',
	margin: `${token('space.100', '8px')} 0`,
});
